import React, { useContext,useState,useEffect } from "react";
import constants from "../../../constants";
import MockTestLibraryCards from "./MockTestLibraryCards";
import LeftArrowPagination from "../../../Svg/LeftArrowPagination";
import RightArrowPagination from "../../../Svg/RightArrowPagination";
import { MockTestPageContext } from "../../../context/MockTestPageContext";
import MockTestLibraryHooks from "../../../Hooks/Mock/Student/MockTestLibraryHooks";
import MockTestDetailsHooks from "../../../Hooks/Mock/Student/MockTestDetailsHooks";
import { getDataFromStorage } from "../../../util";
import AlertContext from "../../../context/AlertContext";
export default function MockTestLibrary() {
  const Alert = useContext(AlertContext)
  const companyId = parseInt(localStorage.getItem("companyId"), 10);
  const stored = localStorage.getItem("account_response");
  const [enabledFeatures, setEnableFeatures] = useState([]);

  useEffect(() => {
    MockTestPageCxt.setSearchText("");
    if (!stored) return;

    try {
      const decoded = JSON.parse(atob(stored));
      const companies = Array.isArray(decoded) ? decoded : [decoded];

      const selectedCompany = companies.find(
        (c) => c.company_id === companyId || c.id === companyId
      );

      if (selectedCompany && selectedCompany.premium_features) {
        const rawFeatures = selectedCompany.premium_features;
        const features = typeof rawFeatures === "string"
          ? JSON.parse(rawFeatures)
          : rawFeatures;

        if (Array.isArray(features)) {
          const enabled = features
            .map((feature) =>
              feature.premium_feature_name??
              feature.premium_feature_label??
              feature.name??
              feature.premium_features
            )
            .filter(Boolean);

          setEnableFeatures(enabled);
          localStorage.setItem(
            "enabled_features",
            btoa(JSON.stringify(features))
          );
        }
      }
    } catch (error) {
      console.error("Error decoding account_response:", error);
    }
  }, [stored, companyId]);

  console.log("\n\n\n\n----------Mock enabled features -------------\n\n\n\n",enabledFeatures);

  const MockTestPageCxt = useContext(MockTestPageContext);

  const MockTestLibraryHks = MockTestLibraryHooks();

  MockTestDetailsHooks();

  return (
    <div className="mockTestLibraryMainContainer">
      {MockTestPageCxt.searchMockTest.filter((test) => test.relevant).length >
        0 && (
        <div className="mockTestsCardHolder">
          <p className="mockTestHeads">Relevant To You</p>
          {MockTestPageCxt.searchMockTest.filter((test) => test.relevant)
            .length >= 3 && (
            <LeftArrowPagination
              onClick={() => MockTestLibraryHks.scroll("left", "relevant")}
            />
          )}
          <div
            className="relevantMockTestContainer"
            ref={MockTestLibraryHks.mockTestRefs.relevant}
          >
            {MockTestPageCxt.searchMockTest
              .filter((test) => test.relevant)
              .map((test) => (
                <MockTestLibraryCards test={test} />
              ))}
          </div>
          {MockTestPageCxt.searchMockTest.filter((test) => test.relevant)
            .length >= 3 && (
            <RightArrowPagination
              onClick={() => MockTestLibraryHks.scroll("right", "relevant")}
            />
          )}
        </div>
      )}

      {MockTestPageCxt.searchMockTest.filter((test) =>
        test.hasOwnProperty("toc")
      ).length > 0 && (
        <div className="mockTestsCardHolder">
          <p className="mockTestHeads">Test Series</p>
          {MockTestPageCxt.searchMockTest.filter((test) =>
            test.hasOwnProperty("toc")
          ).length >= 3 && (
            <LeftArrowPagination
              onClick={() => MockTestLibraryHks.scroll("left", "group")}
            />
          )}
          <div
            className="groupMockTestContainer"
            ref={MockTestLibraryHks.mockTestRefs.group}
          >
            {MockTestPageCxt.searchMockTest
              .filter((test) => test.hasOwnProperty("toc"))
              .map((test) => (
                <MockTestLibraryCards test={test} />
              ))}
          </div>
          {MockTestPageCxt.searchMockTest.filter((test) =>
            test.hasOwnProperty("toc")
          ).length >= 3 && (
            <RightArrowPagination
              onClick={() => MockTestLibraryHks.scroll("right", "group")}
            />
          )}
        </div>
      )}

      {enabledFeatures.includes("mcq") && MockTestPageCxt.searchMockTest.length > 0 &&
        MockTestPageCxt.searchMockTest.some(
          (test) => test.libtype === constants.libTypeIds.MCQ
        ) && (
          <div className="mockTestsCardHolder">
            <p className="mockTestHeads">MCQs</p>
            {MockTestPageCxt.searchMockTest.filter(
              (test) => test.libtype === constants.libTypeIds.MCQ
            ).length >= 3 && (
              <LeftArrowPagination
                onClick={() => MockTestLibraryHks.scroll("left", "mcq")}
              />
            )}
            <div
              className="mcqMockTestContainer"
              ref={MockTestLibraryHks.mockTestRefs.mcq}
            >
              {MockTestPageCxt.searchMockTest
                .filter((test) => test.libtype === constants.libTypeIds.MCQ)
                .map((test) => (
                  <MockTestLibraryCards test={test} />
                ))}
            </div>
            {MockTestPageCxt.searchMockTest.filter(
              (test) => test.libtype === constants.libTypeIds.MCQ
            ).length >= 3 && (
              <RightArrowPagination
                onClick={() => MockTestLibraryHks.scroll("right", "mcq")}
              />
            )}
          </div>
        )}

      {enabledFeatures.includes("descriptive") && MockTestPageCxt.searchMockTest.length > 0 &&
        MockTestPageCxt.searchMockTest.some(
          (test) =>
            !test.aiMode &&
            !test.videoqn &&
            !test.autoeval &&
            test.libtype === constants.libTypeIds.DESCRIPTIVE
        ) && (
          <div className="mockTestsCardHolder">
            <p className="mockTestHeads">Descriptive</p>
            {MockTestPageCxt.searchMockTest.filter(
              (test) =>
                !test.aiMode &&
                !test.videoqn &&
                !test.autoeval &&
                test.libtype === constants.libTypeIds.DESCRIPTIVE
            ).length >= 3 && (
              <LeftArrowPagination
                onClick={() => MockTestLibraryHks.scroll("left", "descriptive")}
                
              />
            )}
            <div
              className="descMockTestContainer"
              ref={MockTestLibraryHks.mockTestRefs.descriptive}
            >
              {MockTestPageCxt.searchMockTest
                .filter(
                  (test) =>
                    !test.aiMode &&
                    !test.videoqn &&
                    !test.autoeval &&
                    test.libtype === constants.libTypeIds.DESCRIPTIVE
                )
                .map((test) => (
                  <MockTestLibraryCards test={test} />
                ))}
            </div>
            {MockTestPageCxt.searchMockTest.filter(
              (test) =>
                !test.aiMode &&
                !test.videoqn &&
                !test.autoeval &&
                test.libtype === constants.libTypeIds.DESCRIPTIVE
            ).length >= 3 && (
              <RightArrowPagination
                onClick={() =>
                  MockTestLibraryHks.scroll("right", "descriptive")
                }
              />
            )}
          </div>
        )}

      {enabledFeatures.includes("coding_challenge_test") && MockTestPageCxt.searchMockTest.length > 0 &&
        MockTestPageCxt.searchMockTest.some(
          (test) => test.libtype === constants.libTypeIds.CODING_CHALLENGE
        ) && (
          <div className="mockTestsCardHolder">
            <p className="mockTestHeads">Coding Challenges</p>
            {MockTestPageCxt.searchMockTest.filter(
              (test) => test.libtype === constants.libTypeIds.CODING_CHALLENGE
            ).length >= 3 && (
              <LeftArrowPagination
                onClick={() =>
                  MockTestLibraryHks.scroll("left", "codingChallenge")
                }
              />
            )}
            <div
              className="ccMockTestContainer"
              ref={MockTestLibraryHks.mockTestRefs.codingChallenge}
            >
              {MockTestPageCxt.searchMockTest
                .filter(
                  (test) =>
                    test.libtype === constants.libTypeIds.CODING_CHALLENGE
                )
                .map((test) => (
                  <MockTestLibraryCards test={test} />
                ))}
            </div>
            {MockTestPageCxt.searchMockTest.filter(
              (test) => test.libtype === constants.libTypeIds.CODING_CHALLENGE
            ).length >= 3 && (
              <RightArrowPagination
                onClick={() =>
                  MockTestLibraryHks.scroll("right", "codingChallenge")
                }
              />
            )}
          </div>
        )}

      {enabledFeatures.includes("coding_snippet") && MockTestPageCxt.searchMockTest.length > 0 &&
        MockTestPageCxt.searchMockTest.some(
          (test) => test.libtype === constants.libTypeIds.CODING_SNIPPET
        ) && (
          <div className="mockTestsCardHolder">
            <p className="mockTestHeads">Coding Snippet</p>
            {MockTestPageCxt.searchMockTest.filter(
              (test) => test.libtype ===  constants.libTypeIds.CODING_SNIPPET
            ).length >= 3 && (
              <LeftArrowPagination
                onClick={() =>
                  MockTestLibraryHks.scroll("left", "codingSnippet")
                }
              />
            )}
            <div
              className="csMockTestContainer"
              ref={MockTestLibraryHks.mockTestRefs.codingSnippet}
            >
              {MockTestPageCxt.searchMockTest
                .filter(
                  (test) => test.libtype === constants.libTypeIds.CODING_SNIPPET
                )
                .map((test) => (
                  <MockTestLibraryCards test={test} />
                ))}
            </div>
            {MockTestPageCxt.searchMockTest.filter(
              (test) => test.libtype === constants.libTypeIds.CODING_SNIPPET
            ).length >= 3 && (
              <RightArrowPagination
                onClick={() =>
                  MockTestLibraryHks.scroll("right", "codingSnippet")
                }
              />
            )}
          </div>
        )}

      {enabledFeatures.includes("video_test") && MockTestPageCxt.searchMockTest.length > 0 &&
        MockTestPageCxt.searchMockTest.some(
          (test) =>
            test.libtype === constants.libTypeIds.DESCRIPTIVE && test.videoqn
        ) && (
          <div className="mockTestsCardHolder">
            <p className="mockTestHeads">Video Assessment</p>
            {MockTestPageCxt.searchMockTest.filter(
              (test) =>
                test.videoqn &&
                test.libtype === constants.libTypeIds.DESCRIPTIVE
            ).length >= 3 && (
              <LeftArrowPagination
                onClick={() =>
                  MockTestLibraryHks.scroll("left", "videoAssessment")
                }
              />
            )}
            <div
              className="vaMockTestContainer"
              ref={MockTestLibraryHks.mockTestRefs.videoAssessment}
            >
              {MockTestPageCxt.searchMockTest
                .filter(
                  (test) =>
                    test.videoqn &&
                    test.libtype === constants.libTypeIds.DESCRIPTIVE
                )
                .map((test) => (
                  <MockTestLibraryCards test={test} />
                ))}
            </div>
            {MockTestPageCxt.searchMockTest.filter(
              (test) =>
                test.videoqn &&
                test.libtype === constants.libTypeIds.DESCRIPTIVE
            ).length >= 3 && (
              <RightArrowPagination
                onClick={() =>
                  MockTestLibraryHks.scroll("right", "videoAssessment")
                }
                
              />
            )}
          </div>
        )}

        {!Alert.isLoaded && MockTestPageCxt.searchMockTest.length==0 && (
          <div className="mockTestLibraryMainContainer">
          <div className="mockTestNoResults">
            <div className="mockTestNoResultsIcon">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  d="M14.667 25.3333C20.5579 25.3333 25.3337 20.5577 25.3337 14.6667C25.3337 8.77564 20.5579 4 14.667 4C8.77601 4 4.00033 8.77564 4.00033 14.6667C4.00033 20.5577 8.77601 25.3333 14.667 25.3333Z"
                  stroke="#667085"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M28.0003 28L22.2003 22.2"
                  stroke="#667085"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <h3>No tests found</h3>

            <p>
              {MockTestPageCxt.searchText
                ? `No tests match "${MockTestPageCxt.searchText}".`
                : "There are no tests available."}
            </p>
          </div>
        </div>
        )}
    </div>
  );
}
